import { APointLoader } from './components/aPoint-loader/ApointLoader';
import { InstalmentDetailsLoader } from './components/instalment-details-loader/InstalmentDetailsLoader';
import { InternalPaymentLoader } from './components/internal-payment-loader/InternalPaymentLoader';
import { PaymentMethodLoader } from './components/payment-method-loader/PaymentMethodLoader';
import { PaymentSummaryLoader } from './components/payment-summary-loader/PaymentSummaryLoader';
import { QrCodeLoader } from './components/qr-code-loader/QrCodeLoader';
import { PaymentLoaderType } from './types/enums';
import { PaymentLoaderProps } from './types/propTypes';

export const PaymentLoader = ({ loaderType }: PaymentLoaderProps) => {
  switch (loaderType) {
    case PaymentLoaderType.PAYMENT_METHOD:
      return <PaymentMethodLoader />;
    case PaymentLoaderType.QR_CODE:
      return <QrCodeLoader />;
    case PaymentLoaderType.INTERNAL_PAYMENT_METHOD:
      return <InternalPaymentLoader />;
    case PaymentLoaderType.INSTALMENT_DETAILS:
      return <InstalmentDetailsLoader />;
    case PaymentLoaderType.PAYMENT_SUMMARY:
      return <PaymentSummaryLoader />;
    case PaymentLoaderType.APOINT:
      return <APointLoader />;
    default:
      return <></>;
  }
};

export { PaymentLoaderType };
